import Vue from 'vue'
import Router from 'vue-router'

// 页面资源
// TODO 做成响应式 合并pc与mobile组件之间重复的代码
import Tools from '@/views/Tools/Tools.vue'
import Stardand from '@/views/Tools/Stardand.vue'
import FreeMint from '@/views/Tools/FreeMint.vue'
import HoldReflection from '@/views/Tools/HoldReflection.vue'
import USDTReflection from '@/views/Tools/USDTReflection.vue'
import LPReflection from '@/views/Tools/LPReflection.vue'
import MR from '@/views/Tools/MR.vue'
import LPRwithInviter from '@/views/Tools/LPRwithInviter.vue'
import ContractManage from '@/views/Tools/ContractManage.vue'
import ContractDetail from '@/views/Tools/ContractDetail.vue'
import ContactUs from '@/views/Tools/ContactUs.vue'
import Deploy from '@/views/Tools/Deploy.vue'

import GasPrice from '@/views/Tools/GasPrice.vue'
import WalletBalance from '@/views/Tools/WalletBalance.vue'
import TransferToken from '@/views/Tools/TransferToken.vue'
import CreateWallet from '@/views/Tools/CreateWallet.vue'
import Faucet from '@/views/Tools/Faucet.vue'


Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Tools,
      children: [
        { path: '/stardand', component: Stardand },
        { path: '/freeMint', component: FreeMint },
        { path: '/holdReflection', component: HoldReflection },
        { path: '/USDTReflection', component: USDTReflection },
        { path: '/LPReflection', component: LPReflection },
        { path: '/mR', component: MR },
        { path: '/LPWithInviter', component: LPRwithInviter },
        { path: '/contractManage', component: ContractManage },
        { path: '/contractDetail', component: ContractDetail },
        { path: '/contactUs', component: ContactUs },
        { path: '/Deploy', component: Deploy },

        { path: '/gasPrice', component: GasPrice },
        { path: '/walletBalance', component: WalletBalance },
        { path: '/transferToken', component: TransferToken },
        { path: '/createWallet', component: CreateWallet },
        { path: '/faucet', component: Faucet }
      ]
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router